import React, { useState, useEffect } from "react";

export const svg = `<svg viewBox="0 0 28 28"><path d="m11.904 11.979-.006-.005c-.17-.14-.39-.216-.673-.216H9.927a.111.111 0 0 0-.112.111v1.507c0 .06.05.11.112.11h1.298c.287 0 .507-.08.677-.23.166-.155.254-.358.254-.628 0-.33-.097-.531-.252-.65Zm6.774 2.875-.006-.005c-.137-.13-.335-.207-.619-.207H16.57a.111.111 0 0 0-.111.111v1.377c0 .061.05.11.111.11h1.472c.32 0 .526-.076.651-.197.125-.12.204-.314.204-.618 0-.27-.08-.45-.219-.571Zm-2.108-1.778h1.276c.27 0 .453-.062.575-.162.122-.1.193-.25.193-.48 0-.252-.072-.408-.185-.506-.121-.105-.306-.17-.583-.17H16.57a.111.111 0 0 0-.111.111v1.096c0 .061.05.111.111.111Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.65 3.486a3.321 3.321 0 0 0-3.3 0l-6.7 3.84A3.27 3.27 0 0 0 4 10.16v7.678c0 1.17.629 2.25 1.65 2.835l6.7 3.84a3.32 3.32 0 0 0 3.3 0l6.7-3.84A3.27 3.27 0 0 0 24 17.84v-7.68a3.27 3.27 0 0 0-1.65-2.836l-6.7-3.84ZM7.965 17.48v-6.96c0-.271.22-.49.493-.49h2.789c.814 0 1.494.232 2.021.708.532.473.792 1.11.792 1.89 0 .778-.252 1.415-.768 1.888-.509.473-1.198.699-2.045.699h-1.32a.111.111 0 0 0-.112.11v2.155a.49.49 0 0 1-.492.489h-.865a.491.491 0 0 1-.493-.49Zm12.061-.192-.002.003c-.495.467-1.285.678-2.32.678h-2.603a.491.491 0 0 1-.493-.49v-6.96c0-.27.221-.489.493-.489h2.93c.715 0 1.306.21 1.754.647.451.425.68.953.68 1.573 0 .592-.223 1.07-.66 1.42.234.146.432.34.593.579.236.331.35.727.35 1.176 0 .762-.237 1.39-.722 1.863Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
